module.exports = __webpack_public_path__ + "static/media/preview_merchandise.fea69bbd.PNG";